import { Group, Radio, Stack, Title } from '@mantine/core';

import { useEffect } from 'react';

import { useNavigate, useParams } from 'react-router-dom';

import { ResourceList, ImagesList } from '../../components';

const RESOURCE_PAGE_OPTIONS = ['documents', 'images'];
const Resources: React.FC = () => {
  const { organization, pageSection } = useParams();
  const isDocumentsView = pageSection === 'documents' || pageSection === undefined;
  const documentsUrl = `/org/${organization}/resources/documents`;
  const imagesUrl = `/org/${organization}/resources/images`;
  const navigate = useNavigate();

  // redirect to documents tab if param doesn't exist
  useEffect(() => {
    if ((pageSection === undefined || !RESOURCE_PAGE_OPTIONS.includes(pageSection))) {
      navigate(documentsUrl);
    }
  }, [pageSection]);

  const title = (
    <Group>
      <Title ta={'start'} order={6} >
        Resources
      </Title>
      <Radio checked={isDocumentsView} label='Documents' onChange={() => { navigate(documentsUrl); }} />
      <Radio checked={!isDocumentsView} label='Images' onChange={() => { navigate(imagesUrl); }} />
    </Group>
  );

  return (
    <Stack
      flex={1}
      gap={0}
      mt={12}
    >
      {isDocumentsView
        ? <ResourceList
          title={title}
          allowResourceUpload
        />
        : <ImagesList title={title} />
      }
    </Stack>
  );
};

export default Resources;
